import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/sharedDownloadStates";
import deltas from "../../actions/deltas";

const {SET_DOWNLOAD_MONTHLY_CLAIM_STATE} = deltas.actionTypes;

export default createStateReducer(states, null, SET_DOWNLOAD_MONTHLY_CLAIM_STATE);

export const selectIsLoadingDownloadMonthlyClaim = (state) => states.LOADING === state.states.downloadMonthlyClaim.state;
